export default __webpack_public_path__ + "static/media/lost_and_found.f1318118.webp";